const myHelper = {
  install(Vue){

    Vue.filter('formatCurrency', function (ammount=0, currency=0, showCurrency=true) {
      ammount = ammount.toString();
      if(showCurrency){
        return ammount.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + currency;
      }else{
        return ammount.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
    });

  }
};

export default myHelper;
